import SVG from "../../../Components/SVG"

export default function Card({ isOpen = false, onToggle, question, answer, index }) {
  return (
    <details
      open={isOpen}
      className={`rounded-lg select-none bg-zi-bg2-light dark:bg-zi-bg2-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark ${isOpen && "bg-zi-bg1-dark/5 dark:bg-zi-bg1-light/5 ring-1 ring-inset ring-zi-border-dark"}`}
    >
      <summary
        className="flex items-center justify-between gap-3 cursor-pointer p-5"
        onClick={(e) => {
          e.preventDefault()
          if (typeof onToggle === "function") {
            onToggle()
          }
        }}
      >
        <span className="font-medium text-justify text-zi-text-light dark:text-zi-text-dark">
          {question}
        </span>
        <SVG
          name={isOpen ? "minus" : "plus"}
          classname="stroke-zi-text-light dark:stroke-zi-text-dark"
        />
      </summary>

      <div className="p-5 pt-0 leading-relaxed text-justify text-zi-text-light dark:text-zi-text-dark">
        {answer}
      </div>
    </details>
  )
}